function setCookie(name, value, hours) {
var expires = "";
if (hours) {
    var date = new Date();
    //date.setTime(date.getTime() + (days*24*60*60*1000));
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
}
document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
var nameEQ = name + "=";
var ca = document.cookie.split(';');
for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
}
return null;
}
$(".announcement-bar2 span.close").on('click', function () {
    setCookie("announcementBar2Flag", "hide", 365);
    $(this).parents('.announcement-bar2').slideUp();
});
if (getCookie('announcementBar2Flag') == 'hide') {
    $(".announcement-bar2").slideUp();
}
else {
    $(".announcement-bar2").slideDown(500);
}